var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('config-main-title',[_vm._v("\n        Instruções Particular\n    ")]),_c('instrucoes-operadora',{ref:"formulario",attrs:{"id_operadora":1}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }